/* istanbul ignore file */
import Promise from 'bluebird';

const InjectedView = {};

export function injectFactory({
  deps = [],
  path,
}) {
  return new Promise((resolve) => {
    window.require(
      [...deps],
      () => {
        window.require([path], (View) => {
          InjectedView[path] = View;
          resolve(View);
        });
      }
    );
  });
}
